import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

export function CrispChat() {
  useEffect(() => {
    Crisp.configure("fbe4cf61-dda4-45d2-9960-0741af1036a9");
  }, []);

  return null;
}